import { useCallback, useState } from 'react';
import { Button } from 'src/components/ui';
import Icon from 'src/components/Icon';


function CollapsableInputGroup({
  title,
  icon,
  color,
  shouldBeOpen,
  onOpen,
  onClose,
  children
}) {
  const [_open, setOpen] = useState();
  const open = _open || shouldBeOpen;
  const toggle = useCallback(() => {
    const willBeOpen = !open;
    setOpen(willBeOpen);
    if (onClose && !willBeOpen) onClose();
    if (onOpen && willBeOpen) onOpen();
  }, [setOpen, onClose, onOpen, open]);

  return <>
    <Button color={color} outline={!open} title={title} onClick={toggle}>{icon ? <Icon icon={icon} /> : title}</Button>
    {open ? children : null}
  </>;
}

export default CollapsableInputGroup;